import type { User } from '../Modules/User/Model/User';

export const SLOT_OPS_OVERRIDE_TOKEN_KEY = 'slotOpsOverrideToken';

export function getSlotOpsOverrideToken(): string | null {
  return sessionStorage.getItem(SLOT_OPS_OVERRIDE_TOKEN_KEY);
}

export function setSlotOpsOverrideToken(token: string): void {
  sessionStorage.setItem(SLOT_OPS_OVERRIDE_TOKEN_KEY, token);
}

export function clearSlotOpsOverrideToken(): void {
  sessionStorage.removeItem(SLOT_OPS_OVERRIDE_TOKEN_KEY);
}

export function isSlotOpsOverrideActive(
  user?: Pick<User, 'slot_ops_override'> | null,
): boolean {
  return Boolean(user?.slot_ops_override?.active);
}

export function canUseSlotOpsOverride(
  user?: Pick<User, 'is_limited_partner_admin' | 'slot_ops_override'> | null,
): boolean {
  if (!user?.is_limited_partner_admin) return false;

  const override = user.slot_ops_override;
  if (!override) return true;

  if (override.eligible === false) return false;
  if (override.configured === false) return false;

  return true;
}

export function shouldAttachSlotOpsOverrideHeader(url?: string): boolean {
  if (!url) return false;

  const path = url.startsWith('http') ? new URL(url).pathname : url;
  if (path.includes('/auth/me')) return true;

  return path.startsWith('/slots') || path.includes('/slots/');
}
